module.exports = __webpack_public_path__ + "img/8-full-md.f6ff073a.jpg";